import {
  // useEffect,
  useState
} from "react";
// import InputTextField from "../../components/input/inputTextField";
// import { ButtonPrimary } from "../../components/button/ButtonCustoms";
import { AuthApi } from "../../api/auth/auth.api";
import {
  // getNavbarCurrentPath,
  // getToken
} from "../../utils/app.utils";
import { routeName } from "../../routes/routeName";
import { useDispatch } from "react-redux";
import { swalError } from "../../components/alert/swal";
import { setLoading, unsetLoading } from "../../store/loading/loading.slice";
import {
  // Link,
  // NavigateFunction, useNavigate
} from "react-router-dom";
// import { icons } from "../../assets/icons/icons";
import LoginMember from "./LoginMember";
import { useTranslation } from "react-i18next";

type Login = {
  email: string;
  password: string;
};

export default function Login() {
  // const navigate: NavigateFunction = useNavigate();
  // const token = getToken();
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const [form, setForm] = useState<Login>({
    email: "",
    password: "",
  });
  const [otp_data, set_otp_data] = useState<{ email: string, ref: string }>({
    email: "",
    ref: ""
  })
  // const [profile, setProfile] = useState<any>({});

  const handleSubmit = async () => {
    dispatch(setLoading());
    await AuthApi.login(form)
      .then((res) => {
        if (res.status < 300) {
          const data = res.data;
          // const ref_data = data?.data?.ref;
          // if (ref_data) {
          //   set_otp_data({ email: data?.data?.email, ref: data?.data?.ref })
          // } else {
            // console.log(data,'data')
          const token = data.data?.access_token;
          const refresh_token = data?.data?.refresh_token;
          // กันกรณี backend ไม่ส่ง access_token กลับมา (เช่น เปิด OTP)
          // ไม่งั้นจะเก็บสตริง "undefined" แล้วยิง Bearer undefined
          if (!token) {
            swalError((i18n.language === "en" && data?.en) || data?.th || data?.message || t("เข้าสู่ระบบไม่สำเร็จ กรุณาลองใหม่อีกครั้ง"));
            return;
          }
          if (refresh_token) {
            localStorage.setItem("REFRESH_TOKEN", refresh_token);
          }
          localStorage.setItem("TOKEN", token);
          getProfile(token);
          // }
        } else {
          swalError(t("เข้าสู่ระบบไม่สำเร็จ กรุณาลองใหม่อีกครั้ง"));
          return;
        }
      })
      .catch((error) => {
        swalError((i18n.language === "en" && error?.response?.data?.en) || error?.response?.data?.th || error?.response?.data?.message || t("เกิดข้อผิดพลาดในการล็อกอิน"));
      })
      .finally(() => {
        dispatch(unsetLoading());
      });
  };

  const getProfile = async (token: string) => {
    dispatch(setLoading());
    await AuthApi.getUser(token)
      .then((res) => {
        if (res.status < 300) {
          const data = res.data;
          if (data.status < 300) {
            // setProfile(data.data);
            if (data.data?.user_type === "employee") {
              window.location.href = routeName.admission.list_applicants;
            } else if (data.data?.user_type === "advisor") {
              window.location.href = routeName.admission.list_applicants;
            }
            else if (data.data?.user_type === "student") {
              window.location.href = routeName.student.chooseAdvisor;
            }
            else if (data.data?.user_type === "MEMBER") {
              window.location.href = routeName.main.home;
            }
            else {
              window.location.href = routeName.admission.list_applicants;
            }
          }
        } else {
          return;
        }
      })
      .catch((error) => {
        console.log(error.response);
        swalError((i18n.language === "en" && error?.response?.data?.en) || error?.response?.data?.th || error?.response?.data?.message || t("เกิดข้อผิดพลาดในการล็อกอิน"));
      })
      .finally(() => {
        dispatch(unsetLoading());
      });
  };

  // useEffect(() => {
  //   if (token && profile) {
  //     if (profile?.user_type === "employye") {
  //       navigate(routeName.cms.ListOfApplicants);
  //     } else if (profile?.user_type === "advisor") {
  //       navigate(routeName.cms.ListOfApplicants);
  //     } else if (profile?.user_type === "student") {
  //       navigate(routeName.student.chooseAdvisor);
  //     } else {
  //       navigate(routeName.cms.ListOfApplicants);
  //     }
  //   }
  // }, [token, profile]);

  return (
    <LoginMember
      form={form}
      setForm={setForm}
      handleSubmit={handleSubmit}
      mode="ADMIN"
      otp_data={{
        email: otp_data.email,
        ref: otp_data.ref
      }}
    />
  );
}
